import { lazy } from 'react';
import { retry } from '../../../config/utils';

const LenderDocument = lazy(() => retry(() => import(/* webpackChunkName: "LenderDocument" */ "./index")));

export default LenderDocument;